import { connect } from 'react-redux';
import { getIsLoggedIn, getCartCount, getCanUserSeeWatch, getCurrentUserHasCore } from '../../publicSession/selectors';
import { getChatUnreadCount } from '../../Chat/redux/selectors';
const mapStateToProps = (state)=>({
        hasCoreMembership: getCurrentUserHasCore(state),
        chatCount: getChatUnreadCount(state),
        isLoggedIn: getIsLoggedIn(state),
        cartCount: getCartCount(state),
        canSeeOldWatch: getCanUserSeeWatch(state)
    });
export default connect(mapStateToProps);

//# sourceMappingURL=SiteHeaderDesktop.container.js.map